"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./create-domain-record/create-domain-record"), exports);
__exportStar(require("./create-domain/create-domain"), exports);
__exportStar(require("./delete-domain-record/delete-domain-record"), exports);
__exportStar(require("./delete-domain/delete-domain"), exports);
__exportStar(require("./get-domain-record/get-domain-record"), exports);
__exportStar(require("./get-domain/get-domain"), exports);
__exportStar(require("./list-domain-records/list-domain-records"), exports);
__exportStar(require("./list-domains/list-domains"), exports);
__exportStar(require("./update-domain-record/update-domain-record"), exports);
__exportStar(require("./types"), exports);
//# sourceMappingURL=index.js.map